import axios from 'axios';
import { configRefs } from '@utils/constants';
import { timespanToMs } from '../utils/timespan.js';

async function getComponentEntriesRequest(user, timespan) {
  if (!user) {
    return [];
  }
  if (user.role === "student") {
    const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/ComponentEntries?userID=${user.id}&resultPeriodStart=${Math.round(timespanToMs(timespan) / 1000)}&resultPeriodEnd=${Math.round(Date.now() / 1000)}`);
    return res.data;
  } else {
    const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/ComponentEntries/Shared?teacherID=${user.id}&resultPeriodStart=${Math.round(timespanToMs(timespan) / 1000)}&resultPeriodEnd=${Math.round(Date.now() / 1000)}`);
    return res.data;
  }
}

export { getComponentEntriesRequest };
//# sourceMappingURL=request.get-component-entries.js.map
